import { useContext, useEffect } from "react";
import { Route } from "react-router-dom";
import styled from "styled-components";
import { AppContext } from "context/AppContext";

import { Grid } from "@paclife/plds.grid";
import { Spacing } from "@paclife/plds.tokens";

import TabMenu from "common/TabMenu/TabMenu";

import Profile from "pages/Profile/Profile";
import Security from "pages/Security/Security";
import MyTeam from "pages/MyTeam/MyTeam";


const Container = styled(Grid)`
    padding-bottom: ${Spacing[24]};
    margin-top: 90px;
`;

const ScrollContent = styled(Grid)`
    height: calc(100vh - 134px);
    overflow-y: scroll;
    padding: 24px 24px 0 24px;
`;

const MyProfile = () => {
    const {
        user,
        userSession
    } = useContext(AppContext);
    
    const userType = user.custom.type;
    const ssoUser  = userSession.data?.user?.ssoUser;
    let hasTeam = userSession.data?.user?.hasTeam;

    const PROFILETABS = [
        { name: "Profile", path: "/" }
    ];

    useEffect(() => {
        hasTeam = userSession.data?.user?.hasTeam
    }, [userSession]);

    if (!ssoUser) {
        PROFILETABS.push({ name: "Security", path: "/security" });
    }

    if (userType === 'A') {
        PROFILETABS.push({ name: "Manage My Team", path: "/team" });
        if (hasTeam) {
            PROFILETABS.push({ name: "Support Your Team", path: "/select" });
        }
    } else if (userType === "V") {
        PROFILETABS.push({ name: "My Team", path: "/team" });
        PROFILETABS.push({ name: "Support Your Team", path: "/select" });
    }

    return (
        <Container container>
            <Grid item sm={12}>
                <TabMenu tabs={PROFILETABS} />
            </Grid>
            <ScrollContent item sm={12} className="scroll">
                <Route exact path="/" component={Profile} />
                    
                    { !ssoUser &&
                        <Route path="/security" component={Security} />
                    }

                    <Route path={'/team'} render={(props) => <MyTeam {...props} tab={"team"} />}/>

                    { hasTeam && (
                        <Route path={'/select'} 
                            render={(props) => <MyTeam {...props} tab={"select"} />}
                        />) 
                    }
               
            </ScrollContent>
        </Container>
    );
};

export default MyProfile;
